import { connect } from 'react-redux';
import CacheEnableCheckBoxView from '../../components/common/CacheEnableCheckBox';
import { isCacheEnabled } from '../../reducers/analyticsApp';
import { cacheEnable } from '../../actions/cache';

const mapStateToProps = (state) => ({
  cacheEnabled: isCacheEnabled(state),
});

const mapDispatchToProps = {
  onChange: cacheEnable,
};

const CacheEnableCheckBox = connect(mapStateToProps, mapDispatchToProps)(CacheEnableCheckBoxView);

export default CacheEnableCheckBox;
